import { gql } from "@apollo/client";

// Distinct access types already in use on an event — access_type is free-form
// text (ticket-type names), so existing values are the only vocabulary there is.
export const GET_EVENT_ACCESS_TYPES = gql`
  query EventAccessTypes($eventId: Int!) {
    rfid_assets(
      where: {
        event_id: { _eq: $eventId }
        access_type: { _is_null: false, _neq: "" }
      }
      distinct_on: access_type
      order_by: { access_type: asc }
    ) {
      access_type
    }
  }
`;

export const RFID_LIST_QUERY = gql`
  query RfidListQuery($where: rfid_assets_bool_exp!) {
    rfid_assets(where: $where, order_by: { updated_at: desc }) {
      id
      uid
      is_active
      last_four_phone_numbers
      event_id
      attendee_id
      reg_id
      tokens_balance
      access_type
      cash_balance
      promo_balance
      created_at
      updated_at
      notes
      event {
        id
        name
      }
      attendee {
        id
        first_name
        last_name
      }
      is_qr
      user {
        username
      }
    }
  }
`;

export const RFID_BY_ID_QUERY = gql`
  query RfidListQuery($id: Int!) {
    rfid_assets(where: { id: { _eq: $id } }) {
      id
      uid
      is_active
      last_four_phone_numbers
      event_id
      reg_id
      attendee_id
      access_type
      tokens_balance
      promo_balance
      cash_balance
      notes
      attendee {
        id
        first_name
        last_name
      }
    }
  }
`;

export const RFID_BY_ID_QUERY_EXPANDED = gql`
  query RfidListQuery($id: Int!) {
    rfid_assets(where: { id: { _eq: $id } }) {
      id
      uid
      is_active
      last_four_phone_numbers
      event_id
      reg_id
      attendee_id
      access_type
      tokens_balance
      promo_balance
      cash_balance
      notes
      attendee {
        id
        first_name
        last_name
      }
      event {
        name
      }
    }
  }
`;

export const RFID_BY_UID_QUERY_EXPANDED = gql`
  query RfidByUidQuery($uid: String!) {
    rfid_assets(where: { uid: { _eq: $uid } }) {
      id
      uid
      is_active
      last_four_phone_numbers
      event_id
      reg_id
      attendee_id
      access_type
      tokens_balance
      promo_balance
      cash_balance
      notes
      attendee {
        id
        first_name
        last_name
      }
      event {
        name
      }
    }
  }
`;

export const RFID_CASH_BALANCE_HISTORY = gql`
query RFID_CASH_BALANCE_HISTORY($eventId: Int!, $uid: String!) {
  cash_balance_history(where: {event_id: {_eq: $eventId}, uid: {_eq: $uid}}, order_by: {created_at: desc}) {
    added_cash
    cash_balance
    created_at
    customer_email
    customer_name
    customer_phone_number
    event_id
    id
    location_id
    uid
    updated_by
    location {
    name
    }
    user {
    username
    }
  }
}
`;

export const RFID_PROMO_BALANCE_HISTORY = gql`
query RFID_PROMO_BALANCE_HISTORY($eventId: Int!, $uid: String!) {
  promo_balance_history(where: {event_id: {_eq: $eventId}, uid: {_eq: $uid}}, order_by: {created_at: desc}) {
    added_promo
    promo_balance
    created_at
    event_id
    id
    location_id
    uid
    updated_by
    location {
    name
    }
    user {
    username
    }
  }
}
`;

export const RFID_TRANSFER_HISTORY = gql`
query RFID_TRANSFER_HISTORY($eventId: Int!, $uid: String!) {
  cashless_asset_transfer_history(
    where: {
      _or: [
        { source_uid: { _eq: $uid } }
        { destination_uid: { _eq: $uid } }
      ]
      event_id: { _eq: $eventId }
    }
    order_by: { created_at: desc }
  ) {
    id
    source_uid
    source_attendee
    source_before_payload
    source_after_payload
    destination_uid
    destination_attendee
    destination_email
    destination_phone_number
    destination_payload
    destination_cash_balance
    destination_promo_balance
    source_before_cash_balance
    source_after_cash_balance
    source_before_promo_balance
    source_after_promo_balance
    event_id
    created_at
    status
    notes
  }
}
`;
